import React from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import { WithAuthenticatorProps } from '@konecorp/ui-library';

import GlobalState from '../../context/globalState';
import AdminApp from '../AdminApp';

const props = {} as WithAuthenticatorProps;

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#1976d2',
    },
  },
});

const App = (): JSX.Element => {
  return (
    <GlobalState>
      <ThemeProvider theme={theme}>
        {<AdminApp {...props}></AdminApp>}
      </ThemeProvider>
    </GlobalState>
  );
};

export default App;
